module.exports = __webpack_public_path__ + "static/media/diners.9bf7041e.svg";